import { useEffect, useState } from "react";
import ReactApexChart from "react-apexcharts";
import { IChart } from "../../../../../@types/chart.type";
import iconDelete from "./../../../../../assets/_TrashIcon_gray.svg";
import { storageUserGet } from "../../../../../storage/storageUser";
import { IApiResponse } from "../../../../../@types/api-response.type";
import { IOverCostProjects } from "../../../../../@types/widgets.type";
import { getOverCostProjects } from "../../../../../services/api/widgets/widgetsService";
import iconMoney from "../../../../../assets/icon-config_costCenter.svg";
import styles from "./styles.module.scss";

interface OverCostProjectsProps {
  chart: IChart;
  ismodeEdit: boolean;
  deleteChart: (id: string | undefined, widgetId: string) => void;
  rowHeightGrid: number;
}

export function OverCostProjects({
  chart,
  deleteChart,
  ismodeEdit,
  rowHeightGrid,
}: OverCostProjectsProps) {
  const [data, setData] = useState<IOverCostProjects[]>([]);
  const [loading, setLoading] = useState(true);

  const user = storageUserGet();

  function formatCurrency(value: number, locale = "pt-BR", currency = "BRL") {
    return new Intl.NumberFormat(locale, {
      style: "currency",
      currency,
    }).format(value);
  }

  useEffect(() => {
    async function fetchOverCostProjects() {
      try {
        setLoading(true);
        const response = (await getOverCostProjects(
          user.email,
          user?.resourceId as string
        )) as IApiResponse<IOverCostProjects[]>;

        if (response.statusCode === 200) {
          setData(response.result);
        }
      } catch (error) {
        console.log(error);
      } finally {
        setLoading(false);
      }
    }
    fetchOverCostProjects();
  }, [user.email, user?.resourceId]);

  const percentages = data.map((value) => value.percentage);
  const projectsName = data.map((value) => value.projectName);

  const series = [
    {
      data: percentages,
    },
  ];

  const options = {
    chart: {
      type: "bar",
      width: "100%",
      height: { rowHeightGrid },
      zoom: {
        enabled: false,
      },
      toolbar: {
        show: false,
      },
    },
    plotOptions: {
      bar: {
        horizontal: false,
        borderRadius: 4,
        borderRadiusApplication: "end",
      },
    },
    colors: ["#212121"],
    dataLabels: {
      enabled: false,
    },
    stroke: {
      show: true,
      width: 2,
      colors: ["transparent"],
    },
    xaxis: {
      categories: projectsName,
      labels: {
        formatter: (value: string) => {
          return value.length > 10 ? value.slice(0, 10) + "..." : value;
        },
        style: {
          fontSize: "12px",
          fontFamily: "Archivo, sans-serif",
          fontWeight: 500,
          colors: ["#616161"],
        },
      },
    },
    yaxis: {
      labels: {
        formatter: (value: number) => `${value.toFixed(0)}%`,
        style: {
          fontSize: "12px",
          fontFamily: "Archivo, sans-serif",
          fontWeight: 500,
          colors: ["#616161"],
        },
      },
    },
    fill: {
      opacity: 1,
    },
    tooltip: {
      custom: function ({
        dataPointIndex,
      }: {
        dataPointIndex: number;
      }) {
        const project = data[dataPointIndex];

        return `
          <div class='labelCustom'>
            <span><b>${project.projectName}</b></span>
            <span>Orçado: ${formatCurrency(project.cost)}</span>
            <span>Atual: ${formatCurrency(project.allocatedCost)}</span>
            <span class='redColor'>Variação: ${project.percentage.toFixed(
              0
            )}%</span>
          </div>
        `;
      },
    },
  };

  return (
    <div className={styles.widget}>
      <div className={styles.header}>
        <h3>
          <img src={iconMoney} alt="" />
          Projetos Acima do Custo
        </h3>
      </div>
      <div style={{ width: "100%", height: "100%" }}>
        {loading ? (
          <p style={{ textAlign: "center", color: "#212121" }}>Carregando...</p>
        ) : (
          <>
            {data.length ? (
              <ReactApexChart
                options={options}
                series={series}
                type="bar"
                width="100%"
                height={rowHeightGrid - 46}
              />
            ) : (
              <div
                style={{
                  textAlign: "center",
                  padding: "2rem",
                  color: "#616161",
                }}
              >
                <p style={{ marginTop: "1rem" }}>Nenhum dado encontrado.</p>
              </div>
            )}
          </>
        )}
      </div>
      {ismodeEdit && (
        <button onClick={() => deleteChart(chart.id, chart.widgetId)}>
          <img src={iconDelete} alt="" />
        </button>
      )}
    </div>
  );
}
